import { isEuropeRegion } from "@/utils/common/region";

/** Public hell-proxy base for production-EU wingman-v2. There is no staging-EU. */
export const DEFAULT_EU_WINGMAN_V2_URL = "https://api.eu.meetgail.com/v2";

export const trimTrailingSlash = (url: string): string =>
  url.endsWith("/") ? url.slice(0, -1) : url;

export const wingmanLegacyBaseUrl = (): string =>
  trimTrailingSlash(process.env.NEXT_PUBLIC_WINGMAN_URL ?? "");

export const wingmanV2BaseUrl = (): string => {
  const configured = trimTrailingSlash(process.env.NEXT_PUBLIC_WINGMAN_V2_URL ?? "");
  if (configured) return configured;
  return isEuropeRegion() ? DEFAULT_EU_WINGMAN_V2_URL : "";
};

/** Europe has no legacy Wingman cutover; chat always uses wingman-v2. */
export const isWingmanV2OnlyRegion = (): boolean => isEuropeRegion();
